import styled from "styled-components";

export const ActiveModalContent = styled.div`
  border: none;
  margin: auto;
  display: flex;
  flex-direction: column;
  flex: flex-column;
  background: var(--black-200) !important;
  width: 55.4375rem;
  max-height: 60rem;
  align-items: center;
  padding: 1.25rem 0rem;
  padding-bottom: 0rem;

  @media (min-width: 1440px) {
    height: auto;
    max-height: 85vh;
  }
`;

export const ActiveModalOverlay = styled.div`
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  background-color: rgba(25, 25, 25, 0.75) !important;

  .tooltip {
    color: var(--white);
    font-family: DM Sans;
    font-size: 0.86rem !important;
    width: 18.75rem;
    opacity: 1 !important;
    text-align: justify;

    span {
      text-decoration: underline;
    }
  }
`;

export const MoreDetailsContent = styled.div`
  max-width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;

  header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 2rem;
    padding-bottom: 1.25rem;
    width: 100%;
    border-bottom: 1px solid rgba(82, 82, 82, 0.64);
  }

  img {
    cursor: pointer;
  }
`;

export const AlertBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  top: 2px;
  right: 16.75rem;
  padding: 0.33rem;
  width: 1.5rem;
  height: 1.5rem;
  background: var(--grey-300);
  border-radius: 6.25rem;
  cursor: pointer;

  span {
    font-size: 1rem;
    color: var(--white);
    font-weight: 500;
  }
`;

export const ReportContent = styled.div`
  width: 100%;
  max-height: 37rem;
  overflow-y: scroll;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid var(--black-300);
  padding: 1rem;
  width: 100%;
  height: 9.125rem;

  textarea {
    padding: 1rem;
    width: 100%;
    height: 7.0625rem;
    background: var(--black-100);
    border-radius: 10px;
    font-family: "inter", sans-serif;
    resize: none;
    &:focus {
      outline: none;
    }
  }

  button {
    width: 8rem;
    margin-left: 1rem;
    transition: background 0.3s;
    background-color: var(--primary) !important;
    color: black !important;
    &:disabled {
      background-color: var(--white) !important;
      cursor: default;
    }
  }

  button:last-of-type {
    margin-top: 1rem;
    background-color: var(--black-100) !important;
    color: var(--white) !important;

    &:disabled {
      background: var(--grey-300) !important;
      cursor: default;
    }
  }
`;

export const CommentsSection = styled.div`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: start;
  gap: 1rem;

  p {
    max-width: 100%;
    word-break: break-all;
  }

  input {
    background-color: transparent;
    width: 100%;
    height: 0.5rem;
    padding: 0.5rem 0;
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.5rem;
    color: var(--white);
    margin-bottom: 1rem;
    margin-top: 1rem;
  }

  div {
    display: flex;
    flex-direction: row;
    align-items: baseline;

    h3 {
      font-size: 1rem;
      color: var(--primary);
      font-family: "inter", sans-serif;
    }
    h4 {
      font-size: 0.85rem;
    }
    h4::before {
      content: "•";
      margin-right: 0.35rem;
      margin-left: 0.35rem;
    }
  }

  p {
    cursor: pointer;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  &:first-of-type {
    border-top: 2px solid var(--grey-300);
    padding-top: 1rem;
  }

  border-bottom: 2px solid var(--grey-300);

  &:last-of-type {
    border-bottom: none;
  }
`;

export const EditButton = styled.button`
  font-size: 0.85rem;
  text-decoration: underline;
  margin-left: 0.5rem;
  color: white;
  background: transparent;
`;

export const NoComments = styled.h4`
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.5rem;
  text-align: center;
  color: var(--grey-200);
  margin: auto;
`;
